// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"0768f355","331":"5fd3ee1f","641":"0492582d"}[chunkId] + ".chunk.js";
};